import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import axios from "axios";
import { base_url } from "../../../utils/AxiosConfig";

let LeaveCatschema = Yup.object().shape({
  CmpCode: Yup.string(),
  name: Yup.string().required("Title required"),
  icon: Yup.string(),
  // code: Yup.string().required("Code required"),
  type: Yup.string(),
  unit: Yup.string(),
  validity_From: Yup.string(),
  validity_To: Yup.string(),
  // effectiveAfter_Input: Yup.string(),
  effectiveAfter_Input: Yup.number(),
  effectiveAfter_List: Yup.string(),
  reset_List: Yup.string(),
  // carryForward_Input: Yup.string(),
  carryForward_Input: Yup.number(),
  carryForward_List: Yup.string(),
  // carryForward_Max: Yup.string(),
  carryForward_Max: Yup.number(),
  // encashment_Input: Yup.string(),
  encashment_Input: Yup.number(),
  encashment_List: Yup.string(),
  // encashment_Max: Yup.string(),
  encashment_Max: Yup.number(),
  appl_Departments: Yup.string(),
  appl_Designations: Yup.string(),
  appl_Locations: Yup.string(),
  appl_role: Yup.string(),
  appl_Gender: Yup.string(),
  appl_MaritalStatus: Yup.string(),
  appl_EmployementType: Yup.string(),
});
const CreateLeaveCatPopup = ({ handleClose, getLeave }) => {
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  const [isModalVisible, setModalVisible] = useState(true);
  const [CreateData, setCreateData] = useState(null);
  const [Code, setCode] = useState(null);
  const [Name, setName] = useState(null);
  const [DupCheckCode, setDupCheckCode] = useState(false);
  const [DupCheckName, setDupCheckName] = useState(false);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      CmpCode: companyCode,
      name: "",
      icon: "-",
      code: "",
      type: "",
      unit: "",
      validity_From: "1900-01-01",
      validity_To: "1900-01-01",
      // effectiveAfter_Input: "0",
      effectiveAfter_Input: 0,
      effectiveAfter_List: "",
      reset_List: "-",
      // carryForward_Input: "0",
      carryForward_Input: 0,
      carryForward_List: "-",
      // carryForward_Max: "0",
      carryForward_Max: 0,
      // encashment_Input: "0",
      encashment_Input: 0,
      encashment_List: "",
      // encashment_Max: "0",
      encashment_Max: 0,
      appl_Departments: "-",
      appl_Designations: "-",
      appl_Locations: "-",
      appl_role: "-",
      appl_Gender: "-",
      appl_MaritalStatus: "-",
      appl_EmployementType: "",
    },
    validationSchema: LeaveCatschema,

    onSubmit: (values) => {
      console.log("values:", values);
      console.log("values.code:", values.code);
      setCreateData([values]);
      // setCode(values?.code);
      setCode(values?.name);
      setName(values?.name);
    },
  });

  const closeModal = () => {
    setModalVisible(false);

    // Remove the modal backdrop
    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) {
      backdrop.parentNode.removeChild(backdrop);
    }
  };

  const removeItemsOnClose = async () => {
    setCreateData(null);
    setDupCheckCode(false);
    setDupCheckName(false);

    setCode(null);
    setName(null);

    // Reset the form to its initial values
    formik.resetForm();
  };

  useEffect(() => {
    const DupCheckingCode = async () => {
      try {
        const apiUrl = `${base_url}/api/DupCheck/${companyCode}/LEAVECODE/${Code ? Code : null}`;

        console.log("apiurl CLCP", apiUrl);
        const response = await axios.get(apiUrl);

        if (response.data[0].COUNT === 0) {
          setDupCheckCode(true);
        } else {
          setDupCheckCode(false);
          toast.error("Code Already Exist Try With Another");
        }
      } catch (error) {
        console.log("DupCheckingCode", error);
        toast.error("Some error occured");
        setCreateData(null);
        setCode(null);
        setName(null);
      }
    };
    if (Code) {
      DupCheckingCode();
    }
  }, [Code]);

  useEffect(() => {
    const DupCheckingName = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/DupCheck/${companyCode}/LEAVENAME/${Name ? Name : null}`,
        );

        if (response.data[0].COUNT === 0) {
          setDupCheckName(true);
        } else {
          setDupCheckName(false);
          toast.error("Name Already Exist Try With Another");
        }
      } catch (error) {
        console.log("DupCheckingName", error);
        toast.error("Some error occured");
        setCreateData(null);
        setCode(null);
        setName(null);
      }
    };
    if (Name) {
      DupCheckingName();
    }
  }, [Name]);

  const CreateLeave = async () => {
    try {
      const postData = JSON.stringify(CreateData);

      const response = await axios.post(
        `${base_url}/api/PersonalInfoLeaveCategory`,
        CreateData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (response?.status === 200) {
        toast.success("Leave Category Created Successfully");
        removeItemsOnClose();
        closeModal();
        getLeave();
      } else {
        console.log("error");
      }
    } catch (error) {
      console.log("CreateLeave", error);
      toast.error("Some error occured");
    }
  };

  useEffect(() => {
    if (CreateData && DupCheckCode !== false && DupCheckName !== false) {
      CreateLeave();
      setDupCheckCode(false);
      setDupCheckName(false);
    }
  }, [CreateData, DupCheckCode, DupCheckName]);

  console.log("DupCheckCode", DupCheckCode);
  console.log("DupCheckName", DupCheckName);
  console.log("CreateData", CreateData);
  console.log("Name", Name);
  console.log("Code", Code);

  return (
   
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black/40`}
    >
      {/* Modal */}
      <div className="bg-white w-[95%] max-w-6xl rounded-xl shadow-xl">
        {/* Header */}
        <div className="flex items-center justify-between border-b px-6 py-4 bg-[#2663EB] rounded-t-xl">
          <h1 className="text-lg font-semibold text-white">
            Create Leave Category
          </h1>

          <button
            onClick={() => {
              handleClose();
              removeItemsOnClose();
            }}
            className="text-white hover:text-red-500 text-xl"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          <form onSubmit={formik.handleSubmit}>
            {/* Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* Column 1 */}
              <div>
                <label className="text-sm text-gray-600">Name</label>
                <input
                  type="text"
                  name="name"
                  onChange={(e) => {
                    const value = e.target.value;

                    formik.setFieldValue("name", value);
                    formik.setFieldValue("code", value);
                  }}
                  value={formik.values.name}
                  className="w-full border rounded-lg px-3 py-2 mt-1 focus:ring-2 focus:ring-blue-500"
                />
                <p className="text-red-500 text-xs">
                  {formik.touched.name && formik.errors.name}
                </p>

                {/* <label className="text-sm text-gray-600 mt-4 block">Icon</label>
              <input
                type="text"
                name="icon"
                onChange={formik.handleChange("icon")}
                value={formik.values.icon}
                className="w-full border rounded-lg px-3 py-2 mt-1"
              /> */}

                <label className="text-sm text-gray-600 mt-4 block">
                  Gender
                </label>
                <select
                  name="appl_Gender"
                  onChange={formik.handleChange("appl_Gender")}
                  value={formik.values.appl_Gender}
                  className="w-full border rounded-lg px-3 py-2 mt-1"
                >
                  <option>Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>

                {/* <label className="text-sm text-gray-600 mt-4 block">Code</label>
                <input
                  type="text"
                  name="code"
                  onChange={formik.handleChange("code")}
                  value={formik.values.code}
                  className="w-full border rounded-lg px-3 py-2 mt-1"
                />
                <p className="text-red-500 text-xs">
                  {formik.touched.code && formik.errors.code}
                </p> */}

                <label className="text-sm text-gray-600 mt-4 block">Type</label>
                <select
                  name="type"
                  onChange={formik.handleChange("type")}
                  value={formik.values.type}
                  className="w-full border rounded-lg px-3 py-2 mt-1"
                >
                  <option>Select Type</option>
                  <option value="Paid">Paid</option>
                  <option value="Unpaid">Unpaid</option>
                  <option value="On Duty">On Duty</option>
                  <option value="Restricted Holiday">Restricted Holiday</option>
                </select>
              </div>

              {/* Column 2 */}
              <div>
                <label className="text-sm text-gray-600">Units</label>
                <select
                  name="unit"
                  onChange={formik.handleChange("unit")}
                  value={formik.values.unit}
                  className="w-full border rounded-lg px-3 py-2 mt-1"
                >
                  <option>Select Unit</option>
                  <option value="Days">Days</option>
                </select>

                {/* <div className="grid grid-cols-2 gap-3 mt-4">
                  <div>
                    <label className="text-sm text-gray-600">From Date</label>
                    <input
                      type="date"
                      name="validity_From"
                      onChange={formik.handleChange("validity_From")}
                      value={formik.values.validity_From}
                      className="w-full border rounded-lg px-3 py-2 mt-1"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-gray-600">To Date</label>
                    <input
                      type="date"
                      name="validity_To"
                      onChange={formik.handleChange("validity_To")}
                      value={formik.values.validity_To}
                      className="w-full border rounded-lg px-3 py-2 mt-1"
                    />
                  </div>
                </div> */}

                <label className="text-sm text-gray-600 mt-4 block">
                  Effective After
                </label>

                <input
                  // type="date"
                  type="number"
                  name="effectiveAfter_Input"
                  onChange={formik.handleChange("effectiveAfter_Input")}
                  value={formik.values.effectiveAfter_Input}
                  className="w-full border rounded-lg px-3 py-2 mt-1"
                />

                <label className="text-sm text-gray-600 mt-4 block">
                  Reset
                </label>

                <select
                  name="reset_List"
                  onChange={formik.handleChange("reset_List")}
                  value={formik.values.reset_List}
                  className="w-full border rounded-lg px-3 py-2 mt-1"
                >
                  <option>Select Reset</option>
                  <option value="Yearly">Yearly</option>
                  <option value="Monthly">Monthly</option>
                </select>
              </div>

              {/* Column 3 */}
              <div>
                <label className="text-sm text-gray-600">Carry Forward</label>

                <input
                  // type="text"
                  type="number"
                  name="carryForward_Input"
                  onChange={formik.handleChange("carryForward_Input")}
                  value={formik.values.carryForward_Input}
                  className="w-full border rounded-lg px-3 py-2 mt-1"
                />

                <label className="text-sm text-gray-600 mt-4 block">
                  Encashment
                </label>

                <input
                  // type="text"
                  type="number"
                  name="encashment_Input"
                  onChange={formik.handleChange("encashment_Input")}
                  value={formik.values.encashment_Input}
                  className="w-full border rounded-lg px-3 py-2 mt-1"
                />
              </div>
            </div>

            {/* Save Button */}
            <div className="flex justify-center items-center mt-6">
              <button
                type="submit"
                className="bg-blue-600 font-semibold text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateLeaveCatPopup;
